import { call, put, takeLatest } from 'redux-saga/effects';
import { delay } from 'redux-saga'

import {GET_LAST_COMMENTS} from "../actions/types";
import { showGeneralError, hideGeneralError } from '../actions/general.actions';
import { getLastCommentsSucceeded } from '../actions/comments.actions';
import { GENERIC_ERROR_MESSAGE} from "../config/messages";
import { getLastComments } from "../api/comments.api";
import { showSpinner, hideSpinner } from '../actions/loading.actions';

function* getLastCommentsSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(getLastComments, action.payload);
        if (response.status){
            yield put(hideSpinner());
        }
        if(response.status === 200) {
            yield put(getLastCommentsSucceeded(response.data));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}


export default function* moviesSaga() {
    yield takeLatest(GET_LAST_COMMENTS, getLastCommentsSaga);
}



// WEBPACK FOOTER //
// ./src/SHARED/sagas/comments.saga.js